import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { sha256OfBlob } from './useItemizerAssets';

/**
 * Upload a mission-graph node reference image to its own storage prefix
 * (`graphs/images/`), separate from the item icon library. Content-addressed
 * by SHA-256 so identical images dedupe to one immutable URL.
 *
 * Browser-only (crypto.subtle via sha256OfBlob); call from event handlers.
 */
export async function uploadGraphImage(webp: Blob): Promise<string> {
	const sha = await sha256OfBlob(webp);
	const path = `graphs/images/icon-${sha}.webp`;
	const r = storageRef(getStorage(), path);
	await uploadBytes(r, webp, {
		contentType: 'image/webp',
		cacheControl: 'public, max-age=31536000, immutable',
	});
	return await getDownloadURL(r);
}
